import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastService} from '../../services/toast.service';
import {NgbToastModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'pegasus-toasts-container',
  standalone: true,
  imports: [CommonModule, NgbToastModule],
  templateUrl: './toasts-container.component.html',
  styleUrl: './toasts-container.component.scss',
  host: {class: 'toast-container position-fixed tw-top-0 tw-end-0 tw-p-3', style: 'z-index: 1200'},
})
export class ToastsContainerComponent {
  toastService = inject(ToastService);
}
